import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import * as React from 'react';

export default class Themed extends React.Component {

    private readonly theme = createMuiTheme({
        palette: {
            primary: {
                main: '#795548',
                light: '#a98274',
                dark: '#4b2c20',
                contrastText: '#ffffff'
            },
            secondary: {
                main: '#01579b',
                light: '#4f83cc',
                dark: '#002f6c',
                contrastText: '#ffffff'
            }
        },
        typography: {
            body1: {
                fontSize: '13px'
            }
        }
    });

    public render() {
        return <MuiThemeProvider theme={this.theme}>{this.props.children}</MuiThemeProvider>;
    }
}
